import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Première infraction d'alcool au volant au Québec – Conséquences"
            description="Vous avez été accusé pour alcool au volant, mais vous en êtes à votre première infraction? Avocats Alcool au Volant vous expose toutes les conséquences auxquelles vous faites face."
            fr={undefined}
            lawType="criminal"
            specialtyText="spécialisé en alcool au volant">
            <p>
                Si vous en êtes à votre première infraction d’alcool au volant,
                les possibles conséquences sont les suivantes:
            </p>
            <ul>
                <li>La suspension du permis pour 90 jours,</li>
                <li>L’amende minimale de 1 000 $, </li>
                <li>Le casier judiciaire, et</li>
                <li>L’antidémarreur.</li>
            </ul>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Que faire si vous êtes accusé d’alcool au volant pour la première fois?"
                    alt=""
                />
            </p>
            <p>
                Toutefois, selon le taux d’alcool avec lequel vous êtes
                intercepté, il est possible que les conséquences soient encore
                plus sévères. Ce sera notamment le cas si vous avez un taux
                d’alcool supérieur au double de la limite permise.{' '}
            </p>
            <p>
                <strong>
                    Dans cet article, Avocats Alcool au Volant vous indique les
                    conséquences lorsque vous en êtes à votre première
                    infraction d’alcool au volant!
                </strong>
            </p>
            <h2>
                <strong>
                    L’infraction d’alcool au volant – Que faut-il savoir?
                </strong>
            </h2>
            <p>
                L’infraction d’alcool au volant survient lorsque vous conduisez
                un véhicule avec des facultés affaiblies. Si le policier
                soupçonne que vous êtes dans cet état, il pourra vous demander
                de{' '}
                <strong>
                    passer des tests et de souffler dans un alcootest.
                </strong>
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Bon à savoir!</strong> Pour être reconnu
                            coupable d’alcool au volant, il est souvent question
                            du fameux « 0.08 ». Cela signifie que l’alcootest
                            révèle que vous avez 80 mg d’alcool pour 100 ml de
                            sang.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Même en dessous du barème, cela ne veut pas dire pour autant que
                vous ne risquez aucune conséquence. L’accusation de conduite
                avec les facultés affaiblies n’a pas ces barèmes et donc, si le
                policier considère que vous n’êtes pas en mesure de conduire, il
                pourra prendre les mesures appropriées.
            </p>
            <p>
                Au-dessus du barème, vous serez automatiquement accusé d’avoir
                commis une infraction d’alcool au volant. Dès votre première
                accusation, vous pourrez faire face à quelques conséquences.
            </p>
            <p>
                Si des accusations sont portées contre vous, vous pourrez
                plaider coupable ou non coupable. À ce stade, il est recommandé
                de faire appel à un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-criminel-alcool-volant/">
                    avocat spécialisé dans les affaires d’alcool au volant
                </Link>{' '}
                afin d’entreprendre les démarches.
            </p>
            <h2>
                <strong>
                    Quelles sont les conséquences d’une première infraction
                    d’alcool au volant?
                </strong>
            </h2>
            <p>
                Dès que vous êtes intercepté au volant d’un véhicule avec des
                facultés affaiblies, votre permis sera suspendu et, dans
                certains cas, votre véhicule pourrait être saisi.
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Quelles sont les conséquences de l’alcool au volant?"
                    alt=""
                />
            </p>
            <p>
                La première étape est donc de considérer les sanctions
                administratives. Elles vont survenir avant qu’un verdict soit
                rendu et pourraient tout de même être lourdes de conséquences.
            </p>
            <p>
                Peu importe si vous êtes reconnu coupable ou non d’avoir conduit
                sous l’effet de l’alcool, la SAAQ peut imposer des sanctions au
                conducteur.{' '}
                <strong>
                    1) La suspension de votre permis de conduire (90 jours)
                </strong>
            </p>
            <p>
                La première conséquence lorsque vous êtes intercepté au volant
                d’un véhicule en état d’ébriété est{' '}
                <strong>la suspension de votre permis de conduire </strong>pour
                une durée de 90 jours.
            </p>
            <p>
                Cette sanction va s’appliquer automatiquement, peu importe si
                vous en êtes à votre première infraction d’alcool au volant ou
                si vous êtes en récidive. Puisqu’il s’agit d'une suspension
                ferme de 90 jours, il ne sera pas possible de demander
                l’obtention d’un permis de conduire restreint ou toute autre
                mesure vous permettant de conduire le véhicule.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Attention!</strong> La SAAQ peut prendre la
                            décision de prolonger la suspension de votre permis.
                            Cela est le cas lorsque vous êtes à risque de
                            reproduire les gestes.{' '}
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                <strong>Qu’arrive-t-il à la fin des 90 jours?</strong> Lorsque
                le délai arrive à sa fin, votre permis de conduire vous sera
                automatiquement remis jusqu’à ce que vous ayez à vous présenter
                devant le tribunal. Si vous êtes reconnu coupable, vous serez de
                nouveau soumis à une interdiction de conduire.
            </p>
            <h3>
                <strong>2) Le Programme d’évaluation du risque (SAAQ)</strong>
            </h3>
            <p>
                Après avoir été intercepté par un policier en état d’ébriété
                alors que vous conduisiez, celui-ci peut vous contraindre à
                suivre le{' '}
                <strong>
                    Programme d’évaluation des risques de l’alcool au volant.
                </strong>
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Quelles sont les conséquences administratives de l’alcool au volant?"
                    alt=""
                />
            </p>
            <p>
                Ce programme s’assure que vos habitudes de consommation ne
                posent pas un risque pour votre conduite. Il sera possible de
                déterminer si vous pouvez garder votre permis de conduire ou
                non.
            </p>
            <p>
                Lors d’une première infraction, il est rare que ce programme
                vous soit ordonné. Cependant, dans l’éventualité où votre taux
                d’alcool est <strong>au-dessus du double</strong> de la limite,
                le programme sera obligatoire.
            </p>
            <p>
                Ce sera aussi le cas lorsque vous en êtes à votre deuxième ou
                troisième infraction ou si vous refusez de souffler dans
                l’alcootest. Le succès de l’évaluation sera nécessaire afin
                d’avoir la restitution de votre permis après les 90 jours de
                suspension.
            </p>
            <h3>
                <strong>3) La saisie de votre véhicule</strong>
            </h3>
            <p>
                Selon votre situation, il est possible que les accusations pour
                alcool au volant s'accompagnent de la saisie de votre véhicule.
                Cette sanction ne s’applique généralement qu’en cas de récidive.
                Par conséquent, si vous en êtes à votre première infraction,
                cela ne risque pas de se produire!
            </p>
            <p>
                La saisie du véhicule lors d’une première ne se produit que dans
                l’une des deux situations suivantes:{' '}
            </p>
            <ul>
                <li>Vous refusez de souffler dans l’alcootest, ou</li>
                <li>
                    Vous dépassez le double de la limite d’alcool permise au
                    volant.
                </li>
            </ul>
            <p>
                La saisie du véhicule sera d’une durée d’environ 30 jours. Dans
                tous les cas, serez responsable d
                <strong>es frais de remorquage et d’entreposage </strong>de
                votre véhicule pour toute sa durée.
            </p>
            <h2>
                <strong>
                    Quelles sont les sanctions criminelles de l’alcool au
                    volant?
                </strong>
            </h2>
            <p>
                Contrairement aux sanctions administratives, il faut d’abord
                être reconnu coupable avant les sanctions criminelles.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Que faire si je suis reconnu coupable d’alcool au volant au Québec?"
                    alt=""
                />
            </p>
            <p>
                Le juge devra prendre en considération plusieurs facteurs qui
                peuvent aggraver les peines qui vous seront imposées. Dans le
                cas d’une première infraction, le tribunal est généralement
                moins sévère.
            </p>
            <table>
                <tr>
                    <td>
                        <p>Infraction</p>
                    </td>
                    <td>
                        <p>Première</p>
                    </td>
                    <td>
                        <p>Deuxième</p>
                    </td>
                    <td>
                        <p>Troisième</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Interdiction de conduire</p>
                    </td>
                    <td>
                        <p>Entre 1 et 3 ans</p>
                    </td>
                    <td>
                        <p>Entre 2 et 10 ans</p>
                    </td>
                    <td>
                        <p>Au moins 3 ans</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Interdiction de conduire absolue</p>
                    </td>
                    <td>
                        <p>N/A</p>
                    </td>
                    <td>
                        <p>3 mois</p>
                    </td>
                    <td>
                        <p>6 mois</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Amende minimale</p>
                    </td>
                    <td>
                        <p>Entre 1 000$ et 2 000$</p>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <p>Possibilité d’antidémarreur éthylométrique</p>
                    </td>
                    <td>
                        <p>Oui</p>
                    </td>
                    <td>
                        <p>Oui</p>
                    </td>
                    <td>
                        <p>Oui</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Emprisonnement minimal</p>
                    </td>
                    <td>
                        <p>N/A</p>
                    </td>
                    <td>
                        <p>30 jours</p>
                    </td>
                    <td>
                        <p>120 jours</p>
                    </td>
                </tr>
            </table>
            <p>
                Si vous en êtes à votre première infraction d’alcool au volant,
                la contravention minimale varie en fonction de votre taux
                d’alcool. Voici le montant que vous devrez payer:
            </p>
            <table>
                <tr>
                    <td>
                        <p>Taux d’alcoolémie</p>
                    </td>
                    <td>
                        <p>Contravention à payer</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Entre 80 mg et 119 mg</p>
                    </td>
                    <td>
                        <p>1 000$</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Entre 120 mg et 159 mg</p>
                    </td>
                    <td>
                        <p>1 500$</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>160 mg et plus</p>
                    </td>
                    <td>
                        <p>2 000$</p>
                    </td>
                </tr>
            </table>
            <p>
                Lors des procédures, il est important de faire{' '}
                <strong>
                    appel à un avocat en droit criminel afin que celui-ci puisse
                    vous représenter et mettre en place votre défense.
                </strong>
            </p>
            <p>
                <strong>
                    Heureusement, grâce à Avocats Alcool au Volant, il vous sera
                    possible de trouver le bon avocat gratuitement!
                </strong>
            </p>
            <h2>
                <strong>
                    Trouvez l’avocat qu’il vous faut dès aujourd’hui grâce à
                    Avocats Alcool au Volant
                </strong>
            </h2>
            <p>
                Face à de telles accusations,{' '}
                <Link to="https://avocatsalcoolauvolant.ca/defenses-alcool-volant/">
                    les possibilités de défense
                </Link>{' '}
                sont assez limitées. En effet, si vous souhaitez vous en sortir
                indemne, il sera nécessaire d’orienter votre défense sur l’un
                des points suivants:
            </p>
            <ul>
                <li>La crédibilité de l’alcootest,</li>
                <li>
                    La violation d’un droit fondamental au moment de
                    l’arrestation, ou
                </li>
                <li>Les délais dans la prise d'échantillons.</li>
            </ul>
            <p>
                <strong>
                    Comment faire? Vous n’avez qu’à remplir le formulaire qui se
                    trouve en bas de page, et on se charge de trouver le bon
                    avocat spécialisé en droit criminel près de chez vous, et
                    ce, complètement gratuitement.
                </strong>
            </p>
            <p>
                <strong>
                    N’attendez plus et remplissez le formulaire d’Avocats Alcool
                    au Volant dès maintenant pour trouver le bon professionnel!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "premiere-infraction-alcool-volant/alcool-volant-infraction.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "premiere-infraction-alcool-volant/alcool-volant-consequences.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "premiere-infraction-alcool-volant/alcool-volant-administrative.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "premiere-infraction-alcool-volant/alcool-volant-quebec.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
